export const GetUserById = {
    endpoint: "/users/:user_id",
    pathParams: ["user_id"],
    method: "GET",
    request: undefined,
    response: undefined,
    paginated: false
};
//# sourceMappingURL=GetUserById.js.map